import { FC } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { featuresSelector } from '@/support/Selectors';
import { useSelector } from 'react-redux';
import { DisplayDatatable } from '@/components/Studies/DataTables/Display/DisplayDatatable';
import { DataTableView } from '@/components/UI/DataTableV2/DataTableView';
import { useParams, useSearchParams } from 'react-router-dom';
import { _notNil } from '@/littledash';
import { DataTableProvider } from '@/components/UI/DataTableV2/DataTableProvider';
import { isApiId } from '@/utils/ApiId.utils';

const featureSelector = createSelector([featuresSelector], (features) => ({
  sampleSheetsEnabled: features.sampling_sheets === true,
  datatablesV2Enabled: features.datatables_v2 === true,
}));

export const DatatableVersionSelector: FC = () => {
  const { id: studyId, dataTableId: dataTableApiId } = useParams<{ id: string; dataTableId: string }>();
  const [searchParams] = useSearchParams();
  const { sampleSheetsEnabled, datatablesV2Enabled } = useSelector(featureSelector);
  const isSampleSheet = searchParams.get('type') === 'sample_sheet';
  const useV2 = datatablesV2Enabled || (sampleSheetsEnabled && isSampleSheet);
  if (useV2) {
    if (_notNil(studyId) && isApiId('dtl', dataTableApiId)) {
      return (
        <DataTableProvider studyId={studyId} dataTableApiId={dataTableApiId}>
          <DataTableView />
        </DataTableProvider>
      );
    }
    return null;
  }
  return <DisplayDatatable />;
};
